// theme.ts
import { createTheme } from "@mui/material/styles";
import "@fontsource/poppins"; // Import Poppins font

const theme = createTheme({
  palette: {
    primary: {
      main: "#5F4DA0", // your primary color
    },
    background: {
      default: "#F7F4FF", // background color
      paper: "#FFFFFF",
    },
    text: {
      primary: "#35007B", // heading/text color
      secondary: "#5F4DA0",
    },
  },
  typography: {
    fontFamily: "'Poppins', sans-serif", // apply globally
    h1: { color: "#35007B" },
    h2: { color: "#35007B" },
    h3: { color: "#35007B" },
    h4: { color: "#35007B" },
    h5: { color: "#35007B" },
    h6: { color: "#35007B" },
  },
  components: {
    MuiButton: {
      defaultProps: {
        variant: "contained",
        color: "primary",
      },
      styleOverrides: {
        root: {
          borderRadius: 8,
          textTransform: "none",
          padding: "8px 20px",
          fontFamily: "'Poppins', sans-serif", // ensure buttons use Poppins
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundColor: "#5F4DA0",
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          backgroundColor: "#FFFFFF",
          borderRadius: 12,
          fontFamily: "'Poppins', sans-serif", // ensure card content uses Poppins
        },
      },
    },
  },
});

export default theme;
